import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { LicenseManager } from '@ag-grid-enterprise/core';
import { stripUnrecognizedThemeSegment } from './app/utilities/theme-path';
import { AppSettings } from './app/shared/Constants/sharedConstants';
import { Loader } from '@googlemaps/js-api-loader';
import { registerLicense } from '@syncfusion/ej2-base';

// Registering Syncfusion license key
registerLicense('ORg4AjUWIQA/Gnt2U1hhQlJBfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5Vd01iWnxdcXBQRmlb');


// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function getBaseUrl(): string {
  return document.getElementsByTagName('base')[0].href;
}

const providers = [{ provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }];

if (environment.production) {
  enableProdMode();
}

const bootstrap = () =>
  platformBrowserDynamic(providers)
    .bootstrapModule(AppModule)
    .catch(err => console.log(err));

// Google Maps JS is loaded straight from Google using the referrer-restricted
// browser key. Awaiting it before bootstrap guarantees `google.maps` exists by
// the time any map or address-autocomplete component is constructed.
const loadGoogleMaps = (appConfig: { googleMapClientKey: string; }): Promise<unknown> => {
  const apiKey = appConfig?.googleMapClientKey;

  if (!apiKey) {
    console.error(
      'Google Maps client key is not configured; maps and address autocomplete are unavailable.'
    );
    return Promise.resolve();
  }

  return new Loader({
    apiKey,
    version: '3.64',
    libraries: ['places', 'drawing'],
  })
    .load()
    .catch(err => console.error('Failed to load Google Maps:', err));
};

const launchApp = appConfig => {
  AppSettings.UIAppConfig = appConfig;
  stripUnrecognizedThemeSegment(appConfig);

  if (appConfig && appConfig.agGridKey && appConfig.agGridKey.length > 0) {
    LicenseManager.setLicenseKey(appConfig.agGridKey);
  }

  // A maps failure must not take the whole portal down, so bootstrap either way.
  loadGoogleMaps(appConfig).then(bootstrap);
};

let currentFullPath = encodeURIComponent(window.location.href);
fetch(`api/v1/appstate/GetuiAppConfig?rq=${currentFullPath}`)
  .then(results => results.json())
  .then((results: any) => {
    launchApp(results);
  });
